import React from "react";

export interface ErrorContextSchema {
  error?: unknown;
  setError: (err: unknown) => void;
}

export const ErrorContext = React.createContext<ErrorContextSchema>({} as ErrorContextSchema);
